import React from 'react';
import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import ErrorBoundary from './boundaries/ErrorBoundary';
import { db } from 'config/firebase';
import { resetFirestoreCache, isFirestoreCorruptionError } from 'config/firestoreRecovery';

// Global safety net for Firestore IndexedDB cache corruption. Such failures surface as
// async unhandled promise rejections / window errors (from listener onError callbacks),
// which the React ErrorBoundary structurally cannot catch — so we catch them here at the
// outermost entry point, before any component or listener mounts, covering every screen.
// resetFirestoreCache is one-shot guarded (sessionStorage) so this cannot loop, and the
// detector matches only true corruption signatures so ordinary network errors are ignored.
// (With the in-memory cache this should never fire; it remains as belt-and-suspenders for
// any legacy poisoned IndexedDB during the transition.)
window.addEventListener('unhandledrejection', (event) => {
  if (isFirestoreCorruptionError(event && event.reason)) {
    console.warn('[firestoreRecovery] Corruption detected via unhandledrejection; self-healing.');
    resetFirestoreCache(db);
  }
});
window.addEventListener('error', (event) => {
  if (isFirestoreCorruptionError(event && event.error)) {
    console.warn('[firestoreRecovery] Corruption detected via window.error; self-healing.');
    resetFirestoreCache(db);
  }
});


ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
    <Main>
      <App />
    </Main>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('main')
);



/*
const container = document.getElementById('main');
const root = createRoot(container);
root.render(
    <React.StrictMode>
      <Main>
        <App />
      </Main>
    </React.StrictMode>
);
*/